import React from 'react';

interface Props {
	children: (ref, visible: boolean) => React.ReactNode;
	intersectionObserverOptions?: IntersectionObserverInit;
}

const isElementInViewport = (el, { rootMargin }) => {
	const margin = parseInt(rootMargin, 10);
	const rect = el?.getBoundingClientRect();

	return (
		rect.top >= -margin
		&& rect.left >= -margin
		&& rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + margin
		&& rect.right <= (window.innerWidth || document.documentElement.clientWidth) + margin
	);
};

const IntersectionObserverWrapper: React.FC<Props> = (props) => {
	const {
		children,
		intersectionObserverOptions,
	} = props;
	const ref = React.useRef<HTMLImageElement | null>(null);
	const [visible, setVisible] = React.useState(false);

	React.useEffect(() => {
		if (ref.current) {
			const options = {
				rootMargin: '10px',
				threshold: 0.1,
				...intersectionObserverOptions,
			};
			const intersectionObserver = new IntersectionObserver((entries) => {
				if (entries.some((entry) => entry.isIntersecting)) {
					setVisible(true);
				}
			}, options);

			if (isElementInViewport(ref.current, options)) {
				setVisible(true);
			}

			intersectionObserver.observe(ref.current);
			return () => intersectionObserver.disconnect();
		}
	}, []);

	return <>{children(ref, visible)}</>;
};

export default IntersectionObserverWrapper;
